export const columnsCsv = [
  { label: "Date", key: "date" },
  { label: "Name", key: "name" },
  { key: "mobile", label: "Mobile" },
  { key: "emiratesId", label: "Emirates Id" },
  { key: "companyName", label: "Company" },
  { label: "Branch Id ", key: "branchId" },
  { key: "status", label: "Status" },
];

export const options = [
  { value: "Created", label: "Created" },
  { value: "Pending", label: "Pending" },
  { value: "Rejected", label: "Rejected" },
  { value: "Updated", label: "Updated" },
 
];
